export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-primary-500 rounded-2xl overflow-hidden">
          <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4">
              移动追剧
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-extrabold text-background-50 mb-4">
              随时随地，拿起手机就能看
            </h2>
            <p className="text-sm md:text-base text-background-50/85 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              棒棒TV完美适配手机、平板与电脑，无需下载安装，打开浏览器即可畅享高清观影。
              支持画质切换与倍速播放，地铁通勤、午休摸鱼、睡前刷剧，随时随地不卡顿。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50/15 text-background-50 text-sm font-medium whitespace-nowrap">
                <i className="ri-smartphone-line"></i>
                iOS / Android 适配
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50/15 text-background-50 text-sm font-medium whitespace-nowrap">
                <i className="ri-computer-line"></i>
                电脑大屏畅享
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50/15 text-background-50 text-sm font-medium whitespace-nowrap">
                <i className="ri-speed-up-line"></i>
                智能流畅播放
              </div>
            </div>
          </div>
          <div className="flex-1 flex items-center justify-center p-6 md:p-0">
            <div className="relative w-full max-w-[360px] aspect-[9/16]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20video%20streaming%20interface%20with%20movie%20thumbnails%20in%20warm%20coral%20and%20dark%20theme%2C%20clean%20UI%20design%2C%20floating%20phone%20on%20soft%20gradient%20background%2C%20tech%20product%20photography&width=720&height=1280&seq=bbtv-app-visual&orientation=portrait"
                alt="棒棒TV移动端观影体验"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}